import React from "react";

function Navbar() {
    return <div style={{ backgroundColor: "rgba(0,0,0,0.8)", color: "white" }}>
        <h1>React Meals </h1>
        <a href="/" style={{ margin: "10px", color: "white" }}> Home </a>
        <a href="/" style={{ margin: "10px", color: "white" }}> Orders </a>
        <a href="/" style={{ margin: "10px", color: "white" }}> Contact Us </a>
    </div>


}

export default Navbar;
